import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/login-transactions',
    name: 'loginTransactionData',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'loginTransactionDataList',
        component: () => import('../pages/LoginTransactionDataListPage.vue')
      }
    ]
  }
];

export default routes;
